const HN_ALGOLIA_URL = 'https://hn.algolia.com/api/v1/search';

export async function fetchHackerNewsTopStories({limit = 30} = {}) {
    const url = `${HN_ALGOLIA_URL}?tags=front_page&hitsPerPage=${limit}`;
    const response = await fetch(url);

    if (!response.ok) {
        throw new Error('Failed to fetch Hacker News stories');
    }

    const payload = await response.json();
    const hits = Array.isArray(payload?.hits) ? payload.hits : [];

    return hits.map((hit) => ({
        id: `hn-${hit.objectID}`,
        title: hit.title ?? 'Untitled',
        source_url: hit.url ?? `https://news.ycombinator.com/item?id=${hit.objectID}`,
        text: hit.story_text ? stripHtml(hit.story_text) : null,
        published_at: hit.created_at ?? null,
        fetched_source: 'news.ycombinator.com',
        _hn: {
            points: hit.points ?? 0,
            comments: hit.num_comments ?? 0,
            author: hit.author ?? '',
            hnUrl: `https://news.ycombinator.com/item?id=${hit.objectID}`,
        },
    }));
}

function stripHtml(html) {
    return html.replace(/<[^>]*>/g, '').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#x27;/g, "'").trim();
}
